module.exports = __webpack_public_path__ + "img/Bandet.d69eb045.jpg";